import * as React from 'react';

import './Alert.scss';

export default function Alert(props: IAlertProps) {
  switch (props.type) {
    default:
    case 'error':
      return (
        <div className={`sign-in--alert-error ${props.styleClass}`}>
          {props.children}
        </div>
      );
      break;
  }
}

interface IAlertProps {
  type?: string;
  children?: any;
  styleClass?: string;
}
